import React, { Fragment, useEffect, useState } from 'react';
import SideNav from '../../Components/SideNav';
import Swal from 'sweetalert2';
import cursosHelper from "../../Helpers/Cursos";

import Loader from '../../Components/Loader';

import "./Cursos.css";
import Etiqueta from '../../Components/Cursos/Etiqueta';

const Cursos = () => {
    const [titulo, setTitulo] = useState("Cursos y Diplomados");
    const [flag, setFlag] = useState(false);
    const [cursos, setCursos] = useState([]);
    

    useEffect(() => {
        let area = window.location.pathname.split("/")[2];
        if (area === "1") {
            setTitulo("Animación, Animé y Cómic");
        } else if (area === "2") {
            setTitulo("Audio y Voz");
        } else if (area === "3") {
            setTitulo("Cine y Video");
        } else if (area === "4") {
            setTitulo("Artes plásticas");
        } else if (area === "5") {
            setTitulo("Diseño");
        } else if (area === "6") {
            setTitulo("Emprendimiento");
        } else if (area === "7") {
            setTitulo("Escritura");
        } else if (area === "8") {
            setTitulo("Fotografía");
        } else if (area === "9") {
            setTitulo("Teoría del arte");
        } else if (area === "10") {
            setTitulo("Marketing y la Web");
        } else if (area === "11") {
            setTitulo("Multimedia y Videojuegos");
        } else if (area === "12") {
            setTitulo("Suite de Adobe");
        } else if (area === "13") {
            setTitulo("Artes escénicas");
        } else {
            setTitulo("Error...");
        }
        obtenerCursos(area);
    },[]);

    const obtenerCursos = async tipo => {
        let res = await cursosHelper.obtenerUnCursoArea(tipo);
        if (res.success) {
            setCursos(res.data);
            setFlag(true);
        } else {
            Swal.fire(
                'Error!',
                'No se lograron obtener los cursos, codigo: ' + res.code ,
                'error'
            )
        }
    }

    return (
        <Fragment>
            <SideNav />
            <div className='container'>
                <p className='titulo_solicitud' style={{textAlign:"center"}}>
                    {titulo}
                </p>
                {!flag ? (
                    <div>
                        <Loader />
                    </div>
                ) : (
                    <div id='cursos' className='flex_padre_2_d3'>
                        {cursos.map(curso => (
                            <Etiqueta curso={curso} /> 
                        ))}
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export default Cursos;